import licenziya from './licenziya.jpg';
import ustav from './ustav.jpg';

export const documentsData = [
  {
    header: "ЛИЦЕНЗИЯ НА УПРАВЛЕНИЕ МКД",
    image: licenziya,
    description: "Лицензия ГЖИ МО № 1342 выдана 03 декабря 2015г.",
    file: 'licenziya.pdf',
  },
  {
    header: "УСТАВ ОРГАНИЗАЦИИ",
    image: ustav,
    description: "Утвержден общим собранием участников от 8 октября 2013г.",
    file: 'ustav.zip',
  }
];